import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { SimilaritiesByPerson } from './SimilaritiesByPerson';

export const SimilaritiesByPersonPage = () => {
  useTitle('Разрешение совпадений');

  return (
    <Layout withFooter>
      <SimilaritiesByPerson />
    </Layout>
  );
};
